module.exports = __webpack_public_path__ + "static/media/Outlinegrey.631d21dc.svg";